import application from 'application/application';

import template from './details.template.html';

import controller from './details.controller';

application.config([
	'$stateProvider',
	$stateProvider => {
		$stateProvider
			.state('root.default.movements.list1.details', {
				url: '/detalhar?movements&titulo&paginaAtual',
				views: {
					'movements@root.default.movements': {
						templateUrl: template,
						controller
					}
				},
				data: {
					documentTitle: 'Detalhar Movimentações'
				}
			})
			.state('root.default.movements.list2.details', {
				url: '/detalhar?movements&titulo&paginaAtual',
				views: {
					'movements@root.default.movements': {
						templateUrl: template,
						controller
					}
				},
				data: {
					documentTitle: 'Detalhar Movimentações'
				}
			})
			.state('root.default.movements.list3.details', {
				url: '/detalhar?movements&titulo&paginaAtual',
				views: {
					'movements@root.default.movements': {
						templateUrl: template,
						controller
					}
				},
				data: {
					documentTitle: 'Detalhar Movimentações'
				}
			})
			.state('root.default.movements.list4.details', {
				url: '/detalhar?movements&titulo&paginaAtual',
				views: {
					'movements@root.default.movements': {
						templateUrl: template,
						controller
					}
				},
				data: {
					documentTitle: 'Detalhar Movimentações'
				}
			});
	}
]);
